export enum RegepCompensationModel {
  Monthly = 1,
  Yearly,
}
